import { z } from 'zod/mini'

import { checkoutItemWithShippingSchema } from './cart-item'
import { gtmMetadataShape } from './gtm-metadata'
import { nonEmptyString } from './non-empty-string'
import { requireItemsUnlessTradeInOnly } from './require-items-unless-trade-in-only'
import { tradeInDetailsSchema } from './trade-in-details'

export const addShippingInfoSchema = z
  .strictObject({
    ...gtmMetadataShape,
    event: z.literal('add_shipping_info'),
    has_trade_in: z.boolean(),
    ecommerce: z.strictObject({
      currency: nonEmptyString(),
      value: z.number().check(z.gte(0)),
      shipping: z.number().check(z.gte(0)),
      // Empty when no item has a shipping option (trade-in only cart)
      shipping_tier: z.string(),
      items: z.array(checkoutItemWithShippingSchema),
    }),
    trade_in_details: z.optional(tradeInDetailsSchema),
  })
  .check(requireItemsUnlessTradeInOnly())
